import TriangleLogo from "@/assets/svg/vvv/triangle-logo.svg";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import VVVPrimaryButton from "../design-system/vvv/Button";

export default function Header() {
  const leftEntry = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const rightEntry = {
    hidden: { opacity: 0, x: 60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.4,
        ease: [0.16, 1, 0.3, 1],
        delay: 0.15,
      },
    },
  };

  return (
    <div className="h-fit relative overflow-hidden py-24 xs:py-32 lg:py-24 px-6 md:px-12 4xl:max-w-[100rem] 4xl:mx-auto">
      <motion.div
        className="lg:absolute lg:top-[95px] 1xl:top-[90px] lg:left-12 w-fit flex flex-col gap-6 4xl:gap-6 text-center lg:text-left"
        variants={leftEntry}
        initial="hidden"
        animate="visible"
      >
        <h1
          className="vvv-font text-white text-3xl xs:text-4xl md:text-[45px] lg:text-[30px] 1xl:text-[45px]"
          style={{ lineHeight: 1.1 }}
        >
          WE <span className="text-primary">BOOST</span> YOUR UGC
          <br className="hidden lg:block" />
          EARNINGS & <span className="text-primary">VIEWS</span>
        </h1>
        <div className="flex items-center gap-6 4xl:gap-8 justify-center lg:justify-start">
          <div className="w-[100px] xl:w-[140px] h-[125px] 1xl:w-[190px] 4xl:w-[220px] xl:h-[190px] 1xl:h-[220px] 4xl:h-[255px] overflow-hidden bg-black relative hidden lg:block">
            <video
              preload="metadata"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            >
              <source
                src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/hero-section.mp4"
                type="video/mp4"
              />
            </video>
            <div className="absolute inset-0 bg-[#1B25F2]/20"></div>
          </div>
          <div className="flex flex-col gap-8 lg:gap-6 xl:gap-8">
            <p className="text-sm xs:text-base lg:text-xs xl:text-sm 1xl:text-base max-w-xs lg:max-w-72 1xl:max-w-80">
              Very Viral Videos is a global platform for content licensing and
              distribution, connecting creators with brands and media companies
              through monetized viral content ready for commercial use.
            </p>
            <Link to="/esign" className="block mx-auto md:mx-0">
              <VVVPrimaryButton
                name={
                  <>
                    Become a distributor
                    <ArrowRight />
                  </>
                }
              />
            </Link>
          </div>
        </div>
      </motion.div>

      <div className="hidden lg:block">
        <div className="absolute left-8 md:left-12 bottom-[85px] xs:bottom-[127px] sm:bottom-[132px] md:bottom-[193px] video-container-small lg:hidden">
        <video
          preload="metadata"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source
            src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/hero-section.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-[#1B25F2]/20"></div>
      </div>

      <div className="video-container-main absolute left-1/2 -translate-x-1/2 top-16 lg:top-0">
        <motion.div variants={rightEntry} initial="hidden" animate="visible">
          <video
            preload="metadata"
            autoPlay
            muted
            loop
            playsInline
            className="video"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/for-content-creators.mp4"
              type="video/mp4"
            />
          </video>
          <div className="absolute inset-0 bg-[#1B25F2]/10"></div>
        </motion.div>
      </div>

      <motion.img
        className="absolute bottom-[32px] xs:bottom-[64px] md:bottom-[62px] lg:bottom-[95px] right-7 md:right-10 lg:right-9 max-h-[45px] xs:max-h-[47px] sm:max-h-[52px] md:max-h-[90px] lg:max-h-[140px] xl:max-h-[170px] 1xl:max-h-[200px] 4xl:max-h-[215px]"
        src={TriangleLogo}
        alt="VVV Logo"
        variants={rightEntry}
        initial="hidden"
        animate="visible"
      />
      </div>

      <div
        className="relative mx-auto lg:hidden"
        style={{
          width: "310px",
          height: "200px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div className="absolute left-2 md:left-12 top-[64px] md:bottom-[193px] video-container-small lg:hidden">
          <video
            preload="metadata"
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/hero-section.mp4"
              type="video/mp4"
            />
          </video>
          <div className="absolute inset-0 bg-[#1B25F2]/20"></div>
        </div>

        <div className="video-container-main absolute left-1/2 -translate-x-1/2 top-16 lg:top-0">
          <motion.div variants={rightEntry} initial="hidden" animate="visible">
            <video
              preload="metadata"
              autoPlay
              muted
              loop
              playsInline
              className="video"
            >
              <source
                src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/for-content-creators.mp4"
                type="video/mp4"
              />
            </video>
            <div className="absolute inset-0 bg-[#1B25F2]/10"></div>
          </motion.div>
        </div>

        <motion.img
          className="absolute bottom-[10px] md:bottom-[62px] lg:bottom-[98px] right-[5px] md:right-10 lg:right-8 max-h-[42px] md:max-h-[90px] lg:max-h-[140px] xl:max-h-[170px] 1xl:max-h-[200px] 4xl:max-h-[215px]"
          src={TriangleLogo}
          alt="VVV Logo"
          variants={rightEntry}
          initial="hidden"
          animate="visible"
        />
      </div>
    </div>
  );
}
